module.exports = __webpack_public_path__ + "media/review-badges/rank-10k-e66c080c.svg";